import { render, staticRenderFns } from "./datas_jtdltj_management.vue?vue&type=template&id=4612a787&scoped=true&"
import script from "./datas_jtdltj_management.vue?vue&type=script&lang=js&"
export * from "./datas_jtdltj_management.vue?vue&type=script&lang=js&"
import style0 from "./datas_jtdltj_management.vue?vue&type=style&index=0&id=4612a787&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4612a787",
  null
  
)

export default component.exports